<template>
	<div>
		<div class="animal_container">
				<div style="display: flex;width: 73rem;margin: 0 auto;align-items: center;justify-content: space-between;"> <p style="font-size: 1.5rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;" class="sub_menu_title"> 系统架构</p> <div style="height: 0.125rem;background-color: #E2E2E2;width:90%;margin-top: -1.4rem;"> </div> </div>
				<div class="animal_box_t">
					<div class="animal_box_t_list">
						<div class="sys_box">
							<div>
								<p class="animal_box_t_title">PC应用端</p>
								<p class="animal_box_t_msg">电脑端管理培训考试、伦理申请与动物寄养</p>
							</div>
							<img class="animal_box_t_img" src="../../../assets/static/images/shebei.png">
						</div>
					</div>
					<div class="animal_box_t_list">
						<div class="sys_box">
							<div>
								<p class="animal_box_t_title">微信端应用</p>
								<p class="animal_box_t_msg">实验组申请后审核通知、消息提醒、实验记录和费用记录</p>
							</div>
							<img class="animal_box_t_img" src="../../../assets/static/images/iphone.png">
						</div>
					</div>
					<div class="animal_box_t_list">
						<div class="sys_box">
							<div>
								<p class="animal_box_t_title">手持端应用</p>
								<p class="animal_box_t_msg">动物出入库盘数据点，笼卡、笼位管理</p>
							</div>
							<img class="animal_box_t_img" src="../../../assets/static/images/shouchi.png">
						</div>
					</div>
				</div>
				<div class="animal_box_b">
					<div class="animal_box_b_list">
						<div class="sys_box_list">
							<p class="animal_box_b_title">后台管理</p>
							<p class="animal_box_b_msg">动物实验实现人员管理，生产管理、实验审核、培训管理、门禁管理</p>
						</div>
						<img class="animal_box_b_img" src="../../../assets/static/images/houtai.png" />
					</div>
					<div class="animal_box_b_list">
						<div class="sys_box_list">
							<p class="animal_box_b_title">数据资源</p>
							<p class="animal_box_b_msg">后台对相关数据进行记录与统计，例如对人员流动和动物实验数据进行统计。</p>
						</div>
						<img class="animal_box_b_img" src="../../../assets/static/images/ziyuan.png" />
					</div>
					<div class="animal_box_b_list">
						<div class="sys_box_list">
							<p class="animal_box_b_title">物联网智能硬件</p>
							<p class="animal_box_b_msg">关联相关硬件：超高频RFID手持设备、门禁智能控制器、智能中控台</p>
						</div>
						<img class="animal_box_b_img" src="../../../assets/static/images/wulian.png" />
					</div>
				</div>
			</div>
			<div class="animal_manage_container">
					<div style="display: flex;width: 73rem;margin: 0 auto;align-items: center;justify-content: space-between;"> <p style="font-size: 1.5rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;" class="sub_menu_title"> 动物房管理系统流程</p> <div style="height: 0.125rem;background-color: #E2E2E2;width:80%;margin-top: -1.4rem;"> </div> </div>
					<div class="animal_manage_list">
					<div class="animal_manage_box_t">
							<p style="font-size: 1.25rem;font-family: PingFang-SC-Bold, PingFang-SC;font-weight: bold;color: #6F99FA;margin-top: -2rem;">实验申请</p>
							<div class="animal_manage_box_t_data">
								<img class="circle_img" src="../../../assets/static/images/shenqb.png">
								<p class="animal_manage_box_title">01   填写申请表</p>
							</div>
							<img class="right_img" src="../../../assets/static/images/right.png">
								<div class="animal_manage_box_t_data">
									<img class="circle_img" src="../../../assets/static/images/search.png">
									<p class="animal_manage_box_title">02   管理组初审</p>
								</div>
							<img class="right_img" src="../../../assets/static/images/right.png">
							<div class="animal_manage_box_t_data">
								<img class="circle_img" src="../../../assets/static/images/sheshi.png">
								<p class="animal_manage_box_title">03   分配设施组</p>
							</div>
							<img class="right_img" src="../../../assets/static/images/right.png">
							<div class="animal_manage_box_t_data">
								<img class="circle_img" src="../../../assets/static/images/longzi.png">
								<p class="animal_manage_box_title">04   绑定笼子位</p>
							</div>
					</div>
					<div class="animal_t_data">
						<img class="animal_t_img" src="../../../assets/static/images/ani_jiant_t.png">
						<p class="animal_manage_box_title">不通过</p>
					</div>
					<div class="animal_manage_box_b">
							<p style="font-size: 1.25rem;font-family: PingFang-SC-Bold, PingFang-SC;font-weight: bold;color: #6F99FA;">伦理申请</p>
							<div class="animal_manage_box_b_data">
								<img class="circle_img" src="../../../assets/static/images/shenqb.png">
								<p class="animal_manage_box_title">01   填写申请表</p>
							</div>
							<img class="right_img" src="../../../assets/static/images/right.png">
							<div class="animal_manage_box_b_data">
								<img class="circle_img" src="../../../assets/static/images/search.png">
								<p class="animal_manage_box_title">02   管理组初审</p>
							</div>
							<img class="right_img" src="../../../assets/static/images/right.png">
							<div class="animal_manage_box_b_data">
								<img class="circle_img" src="../../../assets/static/images/sheshi.png">
								<p class="animal_manage_box_title">03   分配设施组</p>
							</div>
					</div>
					<div class="animal_b_data">
					<img class="animal_b_img" src="../../../assets/static/images/ani_jiant_b.png">
					<p class="animal_manage_box_title">不通过</p>
					</div>
					</div>
			</div>	
				<div class="animal_service_container">
						<div style="display: flex;width: 73rem;margin: 0 auto;align-items: center;justify-content: space-between;"> <p style="font-size: 1.5rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;" class="sub_menu_title"> 业务模块功能</p> <div style="height: 0.125rem;background-color: #E2E2E2;width:85%;margin-top: -1.4rem;"> </div> </div>
					<div class="animal_service_list">
						<div class="animal_service_box_small">
							<img class="un_circle_img" src="../../../assets/static/images/tuoyuand.png">
							<p class="un_circle_title">01</p>
							<img class="animal_service_box_img" src="../../../assets/static/images/peixun.png">
							<p class="animal_service_box_title">培训考核</p>
							<p class="animal_service_box_msg">培训考核包含线上伦理培训考核和线下培训报名，培训签到。</p>
						</div>
						<div class="animal_service_box_small">
							<img class="un_circle_img" src="../../../assets/static/images/tuoyuand.png">
							<p class="un_circle_title">02</p>
							<img class="animal_service_box_img" src="../../../assets/static/images/lunli.png">
							<p class="animal_service_box_title">伦理申请</p>
							<p class="animal_service_box_msg">线上伦理申请流程，审核批阅和相应的PDF导出</p>
						</div>
						<div class="animal_service_box_small">
							<img class="un_circle_img" src="../../../assets/static/images/tuoyuand.png">
							<p class="un_circle_title">03</p>
							<img class="animal_service_box_img" src="../../../assets/static/images/shiyanshenq.png">
							<p class="animal_service_box_title">实验申请</p>
							<p class="animal_service_box_msg">实验申请包括实验方案审核、费用计算、实验调整，记录实验信息。</p>
						</div>
						<div class="animal_service_box_lage">
							<img class="un_circle_img" src="../../../assets/static/images/tuoyuand.png">
							<p class="un_circle_title">04</p>
							<img class="animal_service_box_img" src="../../../assets/static/images/dwshengchan.png">
							<p class="animal_service_box_title">动物生产管理</p>
							<p class="animal_service_box_msg" style="padding: 0 9.5rem;">动物实验必须条件为实验动物，对动物生产方面的质量管理，进行生产记录和推进项目时动物发放数量和类型进行记录</p>
						</div>
						<div class="animal_service_box_lage">
							<img class="un_circle_img" src="../../../assets/static/images/tuoyuand.png">
							<p class="un_circle_title">05</p>
							<img class="animal_service_box_img" src="../../../assets/static/images/dwjingyang.png">
							<p class="animal_service_box_title">动物寄养管理</p>
							<p class="animal_service_box_msg" style="padding: 0 9.5rem;">动物实验中对动物的寄养进行严格管理，例如笼位分配和生产动物和内部实验分开，预约笼位、松屋接收等</p>
						</div>
					</div>
				</div>
	</div>
</template>

<script>
	import { scrollAnimation } from '../../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.animal_container {
		.animal_box_t {
			display: flex;
			width: 75rem;
			margin: 0 auto;
		}
	
		.animal_box_t_list {
			width: 24rem;
			height: 13.625rem;
			background: #FFFFFF;
			box-shadow: 0 0.1875rem 0.5rem 0 rgba(175, 175, 175, 0.5);
			margin: 0 1rem;
			padding: 2rem 0;
			padding-left: 1.5rem;
			padding-right: 1.5rem;
			border-radius: 0.5rem;
		}
	
		.animal_box_t_title {
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
		}
	
		.animal_box_t_msg {
			font-size: 0.875rem;
			width: 13.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
	
		.sys_box {
			display: flex;
			// justify-content: center;
			// align-items: center;
			flex-direction: column;
		}
	
		.animal_box_t_img {
			align-self: flex-end;
			margin-top: -6rem;
			margin-right: -0.8rem;
		}
	
		.animal_box_b {
			display: flex;
			width: 75rem;
			margin: 0 auto;
			margin-top: 1rem;
			justify-content: space-between;
		}
	
		.animal_box_b_list {
			position: relative;
			margin: 0 1rem;
			text-align: center;
		}
	
		.sys_box_list {
			position: absolute;
			top: 3rem;
			z-index: 50;
			padding: 0 1.5rem;
		}
	
		.animal_box_b_msg {
			text-align: left;
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 1.3125rem;
		}
	
		.animal_box_b_title {
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			margin-top: -1rem;
			padding-bottom: 0.5rem;
		}
	
		.animal_box_b_img {
			transform: scale(1);
			height: 26.5rem;
			width: 24rem;
			margin-left: -0.7rem;
	
		}
	}
	.animal_manage_list{
		width: 75rem;
		margin: 0 auto;
		.animal_manage_box_t{
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		.animal_manage_box_b{
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 5rem;
		}
		.animal_manage_box_t_data{
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.animal_manage_box_b_data{
			display: flex;
			flex-direction: column;
			align-items: center;
		
		}
		.animal_t_data{
			display: flex;
			flex-direction: column;
			width: 21.375rem;
			height: 6.875rem;
			align-items: center;
			margin-left: 11.5rem;
		}
		.animal_b_data{
			display: flex;
			flex-direction: column;
			width: 21.375rem;
			height: 6.875rem;
			align-items: center;
			margin-left: 32rem;
			transform: scale(0.92);
		}
		.animal_manage_box_title{
			font-size: 1.125rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			margin-top: 1.2rem;
		}
		.right_img{
			margin-top: -3.2rem;
		}
	}
	.animal_service_container{
		padding-bottom: 6rem;
		margin-top: 4rem;
		.animal_service_list{
			width: 75rem;
			margin: 0 auto;
			justify-content: space-between;
		}
		.animal_service_list{
			display: flex;
			flex-wrap: wrap;
			
		}
		.animal_service_box_small{
			width: 23.5rem;
			height: 20rem;
			background: #FFFFFF;
			box-shadow: 0 0.1875rem 0.375rem 0.1875rem rgba(226,226,226,0.5);
			border-radius: 0.375rem;
			position: relative;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		.animal_service_box_lage{
			width: 36.375rem;
			height: 20rem;
			background: #FFFFFF;
			box-shadow: 0 0.1875rem 0.375rem 0.1875rem rgba(226,226,226,0.5);
			border-radius: 0.375rem;
			position: relative;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-top: 4rem;
		}
		.animal_service_box_img{
			// width: 8.25rem;
			height: 8.8125rem;
			transform: scale(0.9);
		}
		.un_circle_img{
			position: absolute;
			height: 5.5rem;
			margin-left: -3rem;
			left: 0;
			top: 0;
		    filter: blur(0.125rem);
		}
		.un_circle_title{
			position: absolute;
			font-size: 3.125rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #FFFFFF;
			left: 0.5rem;
			top: 0;
		}
		.animal_service_box_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			padding-top: 1rem;
			line-height: 1.375rem;
		}
		.animal_service_box_msg{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			padding: 0 3.5rem;
			}
	}
</style>
